/* 
Where to find color names? Here some webpages where we can find it:
https://www.color-name.com/
 */

const GREEN_DARK = '#1FA02E';
const GRAY_DARK = '#888888';
const WHITE = '#FFFFFF';
const GRAY_LIGHT = '#E8E8E8';
const CULTURED = '#F4F4F4';
const PLATINUM = '#E2E2E2';
const MAHOGANY = '#BD2C00';
const GAINSBORO = '#DDDDDD';
const CHINESE_SILVER = '#CCCCCC';
const BLACK = '#000000';
const ARGENT = '#C0C0C0';
const BRIGHT_GRAY = '#EAEAEA';
const ANDROID_GREEN = '#A4C735';
const APPLE_GREEN = '#89A503';
const DARK_CHARCOAL = '#333333';
const GRANITE_GRAY = '#666666';
const TIGERS_EYE = '#EB963C';
const DARK_BLUE = '#0C3C6B';
const LIGHT_BLUE = '#E1F0FF';
const BLUE = '#04009A';
const RED = '#DA0037';

export {
    GREEN_DARK,
    GRAY_DARK,
    WHITE,
    GRAY_LIGHT,
    CULTURED,
    PLATINUM,
    MAHOGANY,
    GAINSBORO,
    CHINESE_SILVER,
    BLACK,
    ARGENT,
    BRIGHT_GRAY,
    ANDROID_GREEN,
    APPLE_GREEN,
    DARK_CHARCOAL,
    GRANITE_GRAY,
    TIGERS_EYE,
    DARK_BLUE,
    LIGHT_BLUE,
    BLUE,
    RED
};